import { EthersContractWrapper } from "./contract";
const bridgeAbi = [
    {
        inputs: [],
        name: "optimisticMintingFeeDivisor",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
export default class TbtcVault extends EthersContractWrapper {
    constructor(runner, address) {
        super({
            address,
            runner,
        }, {
            address,
            abi: bridgeAbi,
        });
    }
    async optimisticMintingFeeDivisor() {
        return (await this.instance.optimisticMintingFeeDivisor());
    }
}
//# sourceMappingURL=tbtc-vault.js.map